export enum cardSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
}

export interface ICardPlaceholderProps {
  size?: cardSize;
}
